<script>
import { mapActions, mapGetters } from 'vuex'
import topPickCard from './top-pick-card.vue'

export default {
  components: {
    topPickCard,
  },
  data() {
    return {
      loading: true,
      players: [],
    }
  },
  computed: {
    ...mapGetters('ui', {
      defaultSeason: 'getDefaultSeason',
    }),
    loaderSkeletons: function() {
      return this.loading ? [0, 1, 2, 3, 4, 5, 6, 7] : []
    },
  },
  watch: {
    defaultSeason: function(newPlayer) {
      this.loadData()
    },
  },
  async created() {
    this.loadData()
  },
  methods: {
    ...mapActions('players', ['getTopPicks']),
    loadData() {
      this.loading = true
      this.getTopPicks().then((players) => {
        this.players = players.filter((player) => {
          return typeof player.id !== 'undefined'
        })
        this.loading = false
      })
    },
  },
}
</script>

<template>
  <div>
    <h3 class="mb-2">{{ $t('top_picks_title') }}</h3>
    <v-row v-if="loading" dense>
      <v-skeleton-loader
        v-for="i in loaderSkeletons"
        :key="i"
        type="card-avatar"
        :class="$style.topPickColSkeleton"
      />
    </v-row>
    <v-row v-else dense>
      <v-col
        v-for="player in players"
        :key="player.id"
        :class="$style.topPickCol"
        md="6"
        sm="12"
      >
        <topPickCard :player="player" />
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.topPickCol {
  composes: fourcol;
}

.topPickColSkeleton {
  composes: fourcol;
  padding: 4px;

  @media (max-width: $screen-sm) {
    width: 50%;
  }

  @media (min-width: $screen-sm) and (max-width: $screen-lg) {
    width: 100%;
    margin-bottom: 5px;
  }
}
</style>
